import { Component,OnInit,AfterViewInit,EventEmitter,Output,OnDestroy } from "@angular/core";
import { NgbModal} from "@ng-bootstrap/ng-bootstrap";
import { DatePipe } from "@angular/common";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
declare var $: any;
import { takeWhile,filter, map, mergeMap } from "rxjs/operators";
import { environment } from "src/environments/environment";

import {
    FvmsAlertService
    ,FvmsApiNoticeService
    ,FvmsApiAuthService
} from "src/app/shared/service";
import { FilterDateTime } from "src/app/shared/filter";
import {
    PagingInfo
    ,FvmsNoticeInfo
} from "src/app/shared/vo";
import { NoticeDetailPopupComponent } from "src/app/fvms/notice/detail.popup/notice.detail.popup.component";
import { MainMenuItems } from "./main-menu-items";

@Component({
    selector: "app-navigation"
    ,templateUrl: "./navigation.component.html"
    ,providers: [DatePipe,FilterDateTime]
})
export class NavigationComponent implements OnInit,AfterViewInit,OnDestroy {
    isContinue:boolean = true; 
    @Output() toggleSidebar = new EventEmitter<void>();
    public config: PerfectScrollbarConfigInterface = {};
    public showSearch = false;
    listItemAlert:any[] = [];
    pagingInfo:PagingInfo = new PagingInfo();
    fvmsNoticeInfo:FvmsNoticeInfo = new FvmsNoticeInfo();
    noticeList:any[]=[];
    newNoticeCnt=0;
    isShowDateSelector:boolean = false;
    userGroupId:number;
    listMenuItems:any[];
    public envName:string = environment.name;
    // 1 : 관리자
    // 100 : 관리자(업체)   // 서울우유 대표 계정 (모든 권한)
    // 200 : 운영자(업체)   // 서울우유 운영 계정 (차량,단말,계정,그룹 관리)
    // 300 : 운영자(그룹)   // 서울우유 하위그룹의 운영 계정 (??)
    // 1000 : 운전자        // 서울우유 운전자 계정
    // 99999 : 일반사용자   // 미정
    // if(limitLevel > userGroupId) ==> show menu

    constructor(
        private modalService: NgbModal
        ,private fvmsAlertService:FvmsAlertService
        ,private fvmsApiNoticeService:FvmsApiNoticeService
        ,private datePipe: DatePipe
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private router: Router
        ,private activatedRoute: ActivatedRoute
    ) {
        let currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.userGroupId = parseInt(currentUserInfo.userGroupId);

        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .pipe(map(() => this.activatedRoute))
            .pipe(
                map(route => {
                    while (route.firstChild) {
                        route = route.firstChild;
                    }
                    return route;
                })
            )
            .pipe(filter(route => route.outlet === 'primary'))
            .pipe(mergeMap(route => route.data))
            .subscribe(event => {
                this.isShowDateSelector = event['isShowDateSelector'];
            });

        this.listMenuItems = MainMenuItems.filter((item,idx) => {
            return item.limitGroupId >= this.userGroupId;
        }).map((item,idx) => {
            item.pathInfo.map((val) => {
                if(val.limitGroupId >= this.userGroupId){
                    item.path = val.path;
                }
            });
            return item;
        });

        this.fvmsNoticeInfo.noticeTarget="LOGIN";
        this.fvmsApiNoticeService.subjectListNotice
            .pipe(takeWhile(() => this.isContinue))
            .subscribe((listItem) => {
                this.noticeList = listItem;
                this.newNoticeCnt = ((this.noticeList.length > 4) ? 4 : this.noticeList.length);
                this.noticeList.forEach(notice => {
                    switch(notice.noticeType){
                        case "ERROR":
                            notice["btn"]="btn-danger";
                            notice["icon"]="ti-alert";
                            break;
                        case "INFO":
                            notice["btn"]="btn-primary";
                            notice["icon"]="ti-announcement";
                            break;
                        case "UPDATE":
                            notice["btn"]="btn-success";
                            notice["icon"]="ti-reload";
                            break;
                        default:
                            notice["btn"]="btn-info";
                            notice["icon"]="ti-info";
                        break;
                    }
                })
            });

        this.fvmsAlertService.getListMessage()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe((listItem) => {
                this.listItemAlert = listItem;
            });
    }

    ngOnInit() {
        this.fvmsApiNoticeService.getListNoticeStartUp(this.fvmsNoticeInfo);
        this.fvmsAlertService.testData();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    // This is for Notifications
    notifications: Object[] = [
        {
            btn: "btn-danger"
            ,icon: "ti-link"
            ,title: "Luanch Admin"
            ,subject: "Just see the my new admin!"
            ,time: "9:30 AM"
        }
        ,{
            btn: "btn-success"
            ,icon: "ti-calendar"
            ,title: "Event today"
            ,subject: "Just a reminder that you have event"
            ,time: "9:10 AM"
        }
        ,{
            btn: "btn-info"
            ,icon: "ti-settings"
            ,title: "Settings"
            ,subject: "You can customize this template as you want"
            ,time: "9:08 AM"
        }
        ,{
            btn: "btn-primary"
            ,icon: "ti-user"
            ,title: "Pavan kumar"
            ,subject: "Just see the my admin!"
            ,time: "9:00 AM"
        }
    ];

    // This is for Mymessages
    mymessages: Object[] = [
        {
            useravatar: "assets/images/users/1.jpg"
            ,status: "online"
            ,from: "Pavan kumar"
            ,subject: "Just see the my admin!"
            ,time: "9:30 AM"
        }
        ,{
            useravatar: "assets/images/users/2.jpg"
            ,status: "busy"
            ,from: "Sonu Nigam"
            ,subject: "I have sung a song! See you at"
            ,time: "9:10 AM"
        }
        ,{
            useravatar: "assets/images/users/2.jpg"
            ,status: "away"
            ,from: "Arijit Sinh"
            ,subject: "I am a singer!"
            ,time: "9:08 AM"
        }
        ,{
            useravatar: "assets/images/users/4.jpg"
            ,status: "offline"
            ,from: "Pavan kumar"
            ,subject: "Just see the my admin!"
            ,time: "9:00 AM"
        }
    ];

    ngAfterViewInit() {
        
    }

    clickAlertMessageRemove(itemAlert){
        this.fvmsAlertService.removeMessage(itemAlert.id);
    }

    clickNoticeDetailModal(noticeItem){
        let modalRef = this.modalService.open(
            NoticeDetailPopupComponent
            ,{
                centered:true
                //,size: "lg"
                ,size: "xl"
                //,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }
        );

        modalRef.componentInstance.inputNoticeItem = noticeItem;

        modalRef.result.then((resultModal) => {
            if(resultModal.type === "ok"){
            
            }
        });
        noticeItem.viewCnt++;
    }

    parseContent(content){
        return decodeURIComponent(content);
    }
}
